import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import Usuario from 'Interface/Usuarios';

interface Autenticacao {
  usuario?: Usuario;
  token?: string;
  refresh_token?: string;
  expires?: string;
  message?: string;
}

const inicial: Autenticacao = {};

export const autenticacao = createSlice({
  name: 'autenticacao',
  initialState: inicial,
  reducers: {
    login: (estado, acao: PayloadAction<Autenticacao>) =>
      (estado = acao.payload),
    refresh: (estado, acao: PayloadAction<Autenticacao>) => ({
      ...estado,
      token: acao.payload.token,
      refresh_token: acao.payload.refresh_token,
    }),
    editarUsuario: (estado, acao: PayloadAction<Autenticacao>) => ({
      ...estado,
      usuario: acao.payload.usuario,
    }),
  },
});

export const { login, refresh, editarUsuario } = autenticacao.actions;

export default autenticacao.reducer;
